interface PageIntroProps {
  title: string;
  text: string;
  image: string;
  alt: string;
}

export default function PageIntro({ title, text, image, alt }: PageIntroProps) {
  return (
    <section className="relative h-[420px] md:h-[520px] overflow-hidden">
      <img src={image} alt={alt} title={alt} className="intro-zoom absolute inset-0 w-full h-full object-cover object-center" />
      <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/75 to-background-50/20" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-background-50 to-transparent" />
      <div className="relative z-10 h-full w-full mx-auto max-w-[1280px] px-4 md:px-8 lg:px-10 flex items-end pb-14 md:pb-20">
        <div className="max-w-2xl">
          <span className="block w-12 h-[3px] bg-primary-500 mb-6" />
          <h1 className="font-heading uppercase text-[44px] md:text-[56px] lg:text-[68px] leading-[0.95]">{title}</h1>
          <p className="mt-5 text-base text-foreground-700 max-w-xl leading-relaxed">{text}</p>
        </div>
      </div>
    </section>
  );
}